export default __webpack_public_path__ + "static/media/Mezzanine Floors.77b442f7.jpg";